import React from 'react';
import { Button } from '../../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from '../../../../components/ui/dropdown-menu';

// Define tailwind colors at -50 shade
const tailwindColors = [
  { name: 'slate-50', bgClass: 'bg-slate-50' },
  { name: 'gray-50', bgClass: 'bg-gray-50' },
  { name: 'zinc-50', bgClass: 'bg-zinc-50' },
  { name: 'neutral-50', bgClass: 'bg-neutral-50' },
  { name: 'stone-50', bgClass: 'bg-stone-50' },
  { name: 'red-50', bgClass: 'bg-red-50' },
  { name: 'orange-50', bgClass: 'bg-orange-50' },
  { name: 'amber-50', bgClass: 'bg-amber-50' },
  { name: 'yellow-50', bgClass: 'bg-yellow-50' },
  { name: 'lime-50', bgClass: 'bg-lime-50' },
  { name: 'green-50', bgClass: 'bg-green-50' },
  { name: 'emerald-50', bgClass: 'bg-emerald-50' },
  { name: 'teal-50', bgClass: 'bg-teal-50' },
  { name: 'cyan-50', bgClass: 'bg-cyan-50' },
  { name: 'sky-50', bgClass: 'bg-sky-50' },
  { name: 'blue-50', bgClass: 'bg-blue-50' },
  { name: 'indigo-50', bgClass: 'bg-indigo-50' },
  { name: 'violet-50', bgClass: 'bg-violet-50' },
  { name: 'purple-50', bgClass: 'bg-purple-50' },
  { name: 'fuchsia-50', bgClass: 'bg-fuchsia-50' },
  { name: 'pink-50', bgClass: 'bg-pink-50' },
  { name: 'rose-50', bgClass: 'bg-rose-50' },
];

interface ColorPickerProps {
  selectedColor: string | undefined;
  onColorSelect: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ selectedColor, onColorSelect }) => {
  // Default to green-50 if no color is selected
  const currentColor = selectedColor || 'green-50';
  const currentBgClass = `bg-${currentColor}`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="p-0 h-8 w-8">
          <div className={`w-6 h-6 rounded-full border ${currentBgClass}`}></div>
          <span className="sr-only">Pick background color</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="p-2 grid grid-cols-6 gap-1 w-60">
        {tailwindColors.map((color) => (
          <DropdownMenuItem
            key={color.name}
            onClick={() => onColorSelect(color.name)}
            className="p-0 m-0 h-8 flex items-center justify-center hover:bg-transparent focus:bg-transparent"
          >
            <div 
              className={`w-6 h-6 rounded-full border ${color.bgClass} ${currentColor === color.name ? 'ring-2 ring-offset-1 ring-black' : ''}`}
              title={color.name}
            >
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ColorPicker;